import { reactive } from 'vue'

import frontend_config from './../static/json/config.json'
import currency from './../static/json/currency.json'

import AccountAPI from './api/account.js';
import ProductAPI from './api/product.js';

export const app = reactive({

  active_currency: {
    'symbol': '₱',
    'name': 'Philippine Peso',
    'symbol_native': '₱',
    'decimal_digits': 2,
    'rounding': 0,
    'code': 'PHP',
    'name_plural': 'Philippine pesos',
    'active': true
  },
  currency_list: currency,

  setActiveCurrency (currency) {
    this.active_currency = currency
  }
})

// LOGGER FUNCTIONS
export const Logger = reactive({
  logs: [],

  log (message) {
    var datetime = new Date()
    this.logs.push(datetime.toLocaleString() + ': ' + message)
    // sessionStorage.setItem('gsm_al', JSON.stringify(this.city))
  }
})

export const util = reactive({

    convertToSlug (string) {
      return (string.replace(/\s/g, '-')).toLowerCase();
    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      
      return month + '/' + day + '/' + year;
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      var ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var blob = new Blob([ab], {type: mimeString});
      return blob;

    },
    isNumericInput(number_input)
    {
      let pattern =/^\d*$/;
      let res = pattern.test(number_input);
      if (!res) {
        return false;
      } else {
        return true;
      }
    }
})

// LOCATION FUNCTIONS
export const Location = reactive({
  location: null,

  getLocation () {
    return this.location
  },
  setLocation (location) {
    this.location = location
    sessionStorage.setItem('gsm_al', JSON.stringify(this.location))
  }
})

// MERCHANT FUNCTIONS
export const Merchant = reactive({
  merchant: {
    merchant_id: 0,
    merchant_weight_limit: 999999999
  },

  getMerchant () {
    return this.merchant
  },
  setMerchant (merchant) {
    this.merchant = merchant
    sessionStorage.setItem('gsm_m', JSON.stringify(this.merchant))
  }
})

// CART FUNCTIONS
export const ShoppingCart = reactive({
  EMPTY_CART: [
    {
      recipient: null,
      products: []
    }
  ],

  active_shopping_cart: 0,
  cart: [
    {
      recipient: null,
      products: []
    }
  ],
  wishlist: [],

  getActiveCartIndex()
  {
    return this.active_shopping_cart;
  },
  setActiveCartIndex(index)
  {
    this.active_shopping_cart = index;
    sessionStorage.setItem('gsm_aci', JSON.stringify(this.active_shopping_cart))

  },
  getCart()
  {
    return this.cart;
  },
  setCart(cart)
  {
    this.cart = cart;
    sessionStorage.setItem('gsm_sc', JSON.stringify(this.cart));
  },
  deleteCart()
  {
    this.cart = [
    {
      recipient: null,
      products: []
    }
  ];
    sessionStorage.removeItem("gsm_sc");
  },
  getCartTotal (discounted = 1) {
    var initial_cart_total = 0
    this.cart.forEach((cart_data, cart_index) => {
      cart_data.products.forEach((product, product_index) => {
        var selling_price = 0;

        if(product.product.sale_type == 'default')
        {
          selling_price = product.product.product_price;
        }
        else
        {
          
              var has_price_off_promo = false;
              var price_off_promo_index = 0;
              if(product.product.promo) {
              product.product.promo.forEach((promo, promo_index)=>{
                if(typeof promo == 'object' && !Array.isArray(promo))
                {
                  if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                    {
              

                       var passed_product_requirements = 0;
                       promo.required_items.forEach((ri,ri_index)=>{
                           ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                            if(p.product.sku == ri.sku_id)
                            {
                              passed_product_requirements+=1;
                            }
                          });
                        });

                      if(passed_product_requirements == promo.required_items.length)
                      {
                         if(promo.promo_minimum_amount <= 0)
                         {
                            if(has_price_off_promo)
                            {
                              if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                              {
                                price_off_promo_index = promo_index;
                                    has_price_off_promo = true;
                              }

                            }
                            else
                            {

                       
                               price_off_promo_index = promo_index;
                                 has_price_off_promo = true;
                              }
                          }
                        
                     
                      }
                    }
                }
              });
            }

                 
            if(has_price_off_promo)
            {
   
  
                selling_price =   (product.product.sale_price);
                 
            }
            else
            {

              selling_price = (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price ) : (product.product.product_sale_price));
            }
            
        }

        initial_cart_total = initial_cart_total + (product.quantity * selling_price)
      })
    });

    var final_cart_total = 0;
    this.cart.forEach((cart_data, cart_index) => {
      cart_data.products.forEach((product, product_index) => {
        var selling_price = 0;
         if(product.product.sale_type == 'default')
        {
          selling_price = product.product.product_price;
        }
        else
        {
         
              var has_price_off_promo = false;
              var price_off_promo_index = 0;
              if(product.product.promo) {
                product.product.promo.forEach((promo, promo_index)=>{
                  if(typeof promo == 'object' && !Array.isArray(promo))
                  {
                     if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                      {
                   

                         var passed_product_requirements = 0;
                         promo.required_items.forEach((ri,ri_index)=>{
                           ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                            if(p.product.sku == ri.sku_id)
                            {
                              passed_product_requirements+=1;
                            }
                          });
                        });

                        if(passed_product_requirements == promo.required_items.length)
                        {
                          
                            if(promo.promo_minimum_amount <= initial_cart_total)
                            {

                              if(has_price_off_promo)
                              {

                                if( product.product.promo[price_off_promo_index].promo_selling_price > promo.promo_selling_price)
                                {
                                  price_off_promo_index = promo_index;
                                      has_price_off_promo = true;
                                }

                              }
                              else
                              {

                                 price_off_promo_index = promo_index;
                                   has_price_off_promo = true;
                                }
                            }
                       
                        }
                      }
                  }
                });
              }

              if(has_price_off_promo)
            {
               selling_price =  product.product.sale_price;
             }
             else
             {
               selling_price = (product.product.product_price == parseFloat(product.product.product_sale_price) ? (product.product.product_price ) : (product.product.product_sale_price));
             }
             
         
        }
       
        final_cart_total = final_cart_total + (product.quantity * selling_price)
      })
    });

    if(discounted)
      return final_cart_total;
    else
      return initial_cart_total;
  },
  getTotalCartItems () {
    var count = 0
    this.cart.forEach((cart_data, cart_index) => {
      cart_data.products.forEach((product, product_index) => {
        count = count + (product.quantity)
      })
    })
    return count
  },
   getTotalCartWeight () {
    var weight = 0;
    this.cart.forEach((cart_data, cart_index) => {
      cart_data.products.forEach((product, product_index) => {
        var product_weight = (product.product.weight ? parseInt(product.product.weight) : 0 );

        weight = weight + (product_weight * product.quantity);
      })
    })
    return weight;
  },
  async addToCart (product, quantity) {
    return new Promise((resolve, reject) => {
      var login_id = Account.getLoginId();
      var token = Account.getToken();
      var customer_id = Account.getCustomerID();
      var is_purchasable = this.isPurchasable(product, quantity)
      if (is_purchasable.status == 'success') {
        var mapped_product = this.mapProduct(product.sku, this.active_shopping_cart)
        if (mapped_product.status == 'success') {

            this.cart[this.active_shopping_cart].products[mapped_product.index].product = product;
            this.cart[this.active_shopping_cart].products[mapped_product.index].quantity += parseInt(quantity);
             sessionStorage.setItem('gsm_sc', JSON.stringify(this.cart));

             if(login_id != '' && token != '')
             {
                var updatecart_request = AccountAPI.updateCart(product.sku, quantity, customer_id, token);
                 updatecart_request.then((response)=>{
                  
                    resolve({
                      status: 'success',
                      message: product.product_name + ' quantity has been updated'
                    });
                });

             }
             else
             {
                 resolve({
                      status: 'success',
                      message: product.product_name + ' quantity has been updated'
                    });
             }
          
        } else {


            this.cart[this.active_shopping_cart].products.push({
              product: product,
              quantity: parseInt(quantity)
            });
            sessionStorage.setItem('gsm_sc', JSON.stringify(this.cart));

            if(login_id != '' && token != '')
            {
               var addcart_request = AccountAPI.addToCart(product.sku, quantity, customer_id, token);
               addcart_request.then((response)=>{
                 
                // console.log(response);
              });
             resolve({
                status: 'success',
                message: product.product_name + ' has been added to your cart'
              });

            }
            else
            {
              resolve({
                  status: 'success',
                  message: product.product_name + ' has been added to your cart'
                });

            }
          
        }
      } else {
        resolve({
          status: 'failed',
          message: is_purchasable.description
        });
      }

    });
  },
  async removeFromCart (product, quantity) {
    return new Promise((resolve, reject) => {
      var login_id = Account.getLoginId();
      var token = Account.getToken();
      var customer_id = Account.getCustomerID();
     
      var mapped_product = this.mapProduct(product.sku, this.active_shopping_cart)
      if (mapped_product.status == 'success') {
        if(quantity > 0)
        {
          this.cart[this.active_shopping_cart].products[mapped_product.index].product = product;
           this.cart[this.active_shopping_cart].products[mapped_product.index].quantity -= parseInt(quantity);
            sessionStorage.setItem('gsm_sc', JSON.stringify(this.cart));

            if(login_id != '' && token != '')
            {
              var updatecart_request = AccountAPI.updateCart(product.sku, quantity, customer_id, token);
               updatecart_request.then((response)=>{
                 
              });
                resolve({
                    status: 'success',
                    message: product.product_name + ' quantity has been updated'
                  });
            }
            else
            {
              resolve({
                  status: 'success',
                  message: product.product_name + ' quantity has been updated'
                });
            }
        }
        else
        {
          this.cart[this.active_shopping_cart].products.splice(mapped_product.index,1);
                sessionStorage.setItem('gsm_sc', JSON.stringify(this.cart));

          if(login_id != '' && token != '')
          {
            var removecart_request = AccountAPI.removeFromCart(product.sku, quantity, customer_id, token);
               removecart_request.then((response)=>{
                  
                  resolve({
                    status: 'success',
                    message: product.product_name + ' has been removed from your cart'
                  });
              });
          }
          else
          {
            resolve({
                    status: 'success',
                    message: product.product_name + ' has been removed from your cart'
                  });

          }

        }
       
      } else {
         resolve({
          status: 'failed',
          message: "Product not found"
        });
       
      }
    });
  },
   isPurchasable (product, quantity) {
      // Quantity = Added Quantity

     var is_purchasable = {
        status: 'success',
        message: 'Purchasable'
      };


      if(!product.stock_status)
      {
        is_purchasable.status = 'failed';
        is_purchasable.description = 'Unable to add ' + product.product_name + " to the cart. Product is currently out of stock";
      }
      else
      {
        if(product.is_inventoriable)
        {
          var map_p = this.mapProduct(product.sku);
          var mapped_quantity = 0;
          if(map_p.status == 'success')
          {
            mapped_quantity = map_p.product.quantity;
          }

          if(parseInt(product.stock_on_hand) == 0)
          {
            is_purchasable.status = 'failed';
            is_purchasable.description = 'Unable to add ' + product.product_name + ' to the cart. Product is currently not available';
          }
          else if(parseInt(product.stock_on_hand) < ( parseInt(quantity) + parseInt(mapped_quantity)))
          {
            is_purchasable.status = 'failed';
            is_purchasable.description = 'Unable to add ' + product.product_name + ' to the cart. No stocks left';
          }
          else if(this.getTotalCartWeight() + (parseInt(product.weight) * quantity) > this.getCartWeightLimit())
          {
            is_purchasable.status = 'failed';
            is_purchasable.description = 'Unable to add ' + product.product_name + ' to the cart. Cart exceeds maximum weight limit';
          }
        }
      }
      

    return is_purchasable;
  },
  mapProduct (sku_id, shopping_cart_id = 0) {
    var mapped_product = null
    var mapped_product_index = 0
    this.cart[shopping_cart_id].products.forEach((product, product_index) => {
      if (product.product.sku == sku_id) {
        mapped_product = product
        mapped_product_index = product_index
      }
    })
    return {
      status: (mapped_product ? 'success' : 'failed'),
      message: (mapped_product ? 'Product found in the shopping cart' : 'Product not found in the shopping cart'),
      product: mapped_product,
      index: mapped_product_index
    }
  },
  addToWishlist (product, quantity) {
      this.wishlist.push({
        product: product,
        quantity: quantity
      })
      sessionStorage.setItem('gsm_wl', JSON.stringify(this.wishlist))
  },
  getCartWeightLimit()
  {
    if(Merchant.merchant.merchant_weight_limit == null || Merchant.merchant.merchant_weight_limit == undefined)
    {
      return 999999999;
    }
    else if(parseInt(Merchant.merchant.merchant_weight_limit) == 0)
    {
      return 999999999;
    }
    else
    {
      return parseInt(Merchant.merchant.merchant_weight_limit);
    }
  },
  changeMerchant(barangay_code)
  {
    return new Promise((resolve, reject) => {
        var change_merchant_response = {
          status: 'success',
          products: [],
          updated: false,
          new_merchant: false,
          change_quantity: false,
        };
        var current_products = [];
        var cart_products = structuredClone(this.cart[this.active_shopping_cart].products);
        cart_products.forEach( (p,p_index)=>{
            var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
            current_products.push(sku_raw);
        });

        var products_request = ProductAPI.getProducts(barangay_code, '', '','', false, false, 'best_seller', 'none', '', 12, 0, current_products);
         products_request.then((response)=>{

            if(response.products.length)
            {

              var new_products = response.products;
              var active_merchant = Merchant.getMerchant();
                if(new_products[0].merchant_id != active_merchant.merchant_id)
                {
                  change_merchant_response.updated  = true;
                  change_merchant_response.new_merchant = true;
                }


              cart_products.forEach( (p,p_index)=>{

                var product_data = {
                  product: null,
                  old_qty: p.quantity,
                  new_qty: 0
                };

                new_products.forEach( (np,np_index)=>{
                  
                  var sku_raw = p.product.sku.substring(0, p.product.sku.indexOf("-"));
                  if(np.sku.includes(sku_raw))
                  {
                    product_data.product = np;
                    product_data.new_qty = p.quantity;

                    if( parseInt(np.stock_on_hand) < p.quantity )
                    {
                      product_data.new_qty = parseInt(np.stock_on_hand);
                 
                      change_merchant_response.updated = true;
                      change_merchant_response.change_quantity = true;
                    }

                  }

                });

                // Add to the possible new cart data
                if(product_data.new_qty != 0)
                {
                  change_merchant_response.products.push(product_data);
                }

                if(product_data.old_qty != product_data.new_qty)
                {
                  change_merchant_response.updated = true;
                  change_merchant_response.change_quantity = true;
                }
              });


              resolve(change_merchant_response);
            }
            else
            {
              change_merchant_response.updated = true;
                  change_merchant_response.change_quantity = true;
              resolve(change_merchant_response);
            }

         });

    });
  }
})


// ACCOUNT FUNCTIONS
export const Account = reactive({
  info: {
    registered_business_name: '',
    trade_name: '',
    province: {
      province_name: '',
      province_code: '',
    },
    city: {
      city_name: '',
      city_code: '',
    },
    barangay: {
      brgy_code: '',
      brgy_name: '',
    },
    address: '',
    sec_no: '',
    dti_no: '',
    tin_no: '',
    sec_file: '',
    dti_file: '',
    tin_file: '',
    first_name: '',
    last_name: '',
    email_address: '',
    telephone_number: '',
    mobile_number: '',
    position: '',
  },
  auth: {
    login_id: '',
    token: '',
    customer_id: '',
    temp_password: false,
  },
  addresses: [],

  getLoginId () {
    return this.auth.login_id;
  },
  setLoginId (login_id) {
    this.auth.login_id = login_id
    sessionStorage.setItem('gsm_at', JSON.stringify(this.auth))
  },
  getToken () {
    return this.auth.token;
  },
  setToken (token) {
    this.auth.token = token
    sessionStorage.setItem('gsm_at', JSON.stringify(this.auth))
  },
  getPasswordStatus () {
    return this.auth.temp_password;
  },
  setPasswordStatus (temp_password) {
    this.auth.temp_password = temp_password
    sessionStorage.setItem('gsm_at', JSON.stringify(this.auth))
  },
  getCustomerID () {
    return this.auth.customer_id;
  },
  setCustomerID (customer_id) {
    this.auth.customer_id = customer_id
    sessionStorage.setItem('gsm_at', JSON.stringify(this.auth))
  },
  getAddresses () {
    return this.addresses;
  },
  setAddresses (addresses) {
     this.addresses = addresses;
    sessionStorage.setItem('gsm_aa', JSON.stringify(this.addresses))
  },
  setInfo(info)
  {
    this.info = info;
     sessionStorage.setItem('gsm_ai', JSON.stringify(this.info))
  },
  getInfo()
  {
    return this.info;
  }
})



// WEBPACK FOOTER //
// ./src/functions.js